import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d850268"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  "data-header": "Title",
  class: "td col-4-medium title"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = ["data-header"]
const _hoisted_5 = ["data-header"]
const _hoisted_6 = ["data-header"]
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "td col-3-medium last-col justify-end" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = ["data-testid"]

import { computed, ref } from 'vue'
import { useGettext } from 'vue3-gettext'
import dayjs from 'dayjs'

import IconUI from '@/components/CommonUI/IconUI.vue'
import WorkDetails from '@/components/MyWorks/WorkDetails.vue'
import EditWork from '@/components/MyWorks/EditWork.vue'
import { WorkStatuses, getWorkStatusColor, getWorkStatusName } from '@/constants'

interface WorkItemProps {
  work: Work,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkItem',
  props: {
    work: {}
  },
  setup(__props: any) {

const props = __props;

const { $gettext } = useGettext()


const isDetailsOpen = ref(false)
const isEditOpen = ref(false)

const isDarkTheme = computed(() => document.body.classList.contains('dark-theme'))
const isWorkEditable = computed(() => Boolean(
  props.work.status === WorkStatuses.rejected.id
  || props.work.status === WorkStatuses.pending.id,
))

function toggleWorkDetails() {
  isDetailsOpen.value = !isDetailsOpen.value

  if (isEditOpen.value) {
    isEditOpen.value = false
  }
}

function toggleWorkEdit() {
  isEditOpen.value = !isEditOpen.value

  if (isDetailsOpen.value) {
    isDetailsOpen.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tr row work-item small-gutter", { 'work-item-details-open': isDetailsOpen.value }]),
    "data-testid": `works-table-item${_ctx.work.id}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "truncate-line",
        title: _ctx.work.title
      }, _toDisplayString(_ctx.work.title), 9, _hoisted_3)
    ]),
    _createElementVNode("div", {
      "data-header": _unref($gettext)('Writers'),
      class: "td col-1-medium count"
    }, _toDisplayString(_ctx.work.writers?.length), 9, _hoisted_4),
    _createElementVNode("div", {
      "data-header": _unref($gettext)('Duration'),
      class: "td col-2-medium"
    }, _toDisplayString(_ctx.work.duration), 9, _hoisted_5),
    _createElementVNode("div", {
      "data-header": _unref($gettext)('Status'),
      class: "td col-2-medium"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["status", _unref(getWorkStatusColor)(Number(_ctx.work.status))]),
        "data-testid": `work-item-status${_ctx.work.id}`
      }, [
        (Number(_ctx.work.status) === _unref(WorkStatuses).terminated.id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref($gettext)('Terminated on')) + " " + _toDisplayString(_unref(dayjs)(_ctx.work.terminated_at).format('DD MMM YYYY')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref($gettext)(_unref(getWorkStatusName)(Number(_ctx.work.status)))), 1))
      ], 10, _hoisted_7)
    ], 8, _hoisted_6),
    _createElementVNode("div", _hoisted_10, [
      (isWorkEditable.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["secondary button-small", isDarkTheme.value ? 'white' : 'black']),
            type: "button",
            "data-testid": `works-edit${_ctx.work.id}`,
            onClick: toggleWorkEdit
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref($gettext)('Edit work')), 1),
            _createVNode(IconUI, { name: "edit" })
          ], 10, _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "button tertiary button-small",
        type: "button",
        "data-testid": `works-more-details${_ctx.work.id}`,
        onClick: toggleWorkDetails
      }, [
        _createElementVNode("span", null, _toDisplayString(isDetailsOpen.value ? _unref($gettext)('Less details') : _unref($gettext)('More details')), 1),
        (isDetailsOpen.value)
          ? (_openBlock(), _createBlock(IconUI, {
              key: 0,
              name: "angle-up"
            }))
          : (_openBlock(), _createBlock(IconUI, {
              key: 1,
              name: "angle-down"
            }))
      ], 8, _hoisted_12)
    ]),
    (isDetailsOpen.value)
      ? (_openBlock(), _createBlock(WorkDetails, {
          key: 0,
          class: "col-12 work-details-wrapper",
          work: _ctx.work
        }, null, 8, ["work"]))
      : _createCommentVNode("", true),
    (isEditOpen.value && isWorkEditable.value)
      ? (_openBlock(), _createBlock(EditWork, {
          key: 1,
          class: "col-12 work-edit",
          work: _ctx.work,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (isEditOpen.value = false))
        }, null, 8, ["work"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})